import React from 'react'
import { Card, CardContent } from '../../components/ui/card'

const ObjectiveQuestion = ({ question, answer, onAnswerChange }) => {
  const handleOptionChange = (optionKey) => {
    onAnswerChange(optionKey)
  }

  // Convert options to array format (handle both object and array formats)
  const optionsArray = question.options 
    ? (Array.isArray(question.options) 
        ? question.options  // Already an array
        : Object.entries(question.options).map(([key, text]) => ({
            key,
            text
          })))  // Convert object to array
    : []

  return (
    <div className="space-y-4">
      {/* Question Text */}
      {(question.question || question.text) && (
        <div className="bg-white p-4 rounded-lg border border-gray-200">
          <p className="text-lg text-gray-900 leading-relaxed">
            {question.question || question.text}
          </p>
        </div>
      )}
      
      <div className="space-y-3">
        {optionsArray.map((option) => (
          <Card key={option.key} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <label className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="radio"
                  name={`question-${question.id}`}
                  value={option.key}
                  checked={answer === option.key}
                  onChange={() => handleOptionChange(option.key)}
                  className="w-4 h-4 text-indigo-600 focus:ring-indigo-500"
                />
                <span className="font-medium text-gray-700">{option.key}.</span>
                <span className="text-gray-900">{option.text}</span>
              </label>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default ObjectiveQuestion
